import React, { useEffect, useState } from "react";
import { cn } from "~/utils";
import { getCourse, getResourceCountForCourse } from "~/utils/courses";
import RecentlyAdded from "./RecentlyAdded";
import Links from "./Links";
import Card from "~/components/parts/Card";
import CoursesDropdown from "~/components/general/CoursesDropdown";
import ManageCoursesLink from "~/components/general/ManageCoursesLink";
import UnitSelector from "~/components/general/UnitSelector";
import { attachCountsToCourse } from "./utils";
import { posthogEventResourceGroupSelected } from "~/utils/posthog/resources";

const LessonResourcesHome = ({
  collections = [],
  courseGroups = [],
  enrichment = [],
  initialCourseId = null,
  initialModuleId = null,
  latestResources = [],
  manageCoursesHref,
  user = null,
}) => {
  const [selectedCourseId, setSelectedCourseId] = useState(initialCourseId);

  const handleCourseChange = (coid) => {
    setSelectedCourseId(coid);
  };

  const [selectedCourse, setSelectedCourse] = useState(null);
  const selectedCourseModules = selectedCourse?.modules ?? [];

  useEffect(() => {
    if (selectedCourseId) {
      const fetchCourse = async () => {
        const course = await getCourse(selectedCourseId);
        setSelectedCourse(course);
        const unitCounts = await getResourceCountForCourse(selectedCourseId);
        const courseWithCounts = attachCountsToCourse(course, unitCounts);
        setSelectedCourse(courseWithCounts);
      };
      fetchCourse();
    }
  }, [selectedCourseId]);

  const userCanManageCourses = ["teacher", "trust", "admin"].includes(
    user?.type,
  );

  return (
    <div className="mx-auto max-w-[800px] p-4 md:mt-[40px] xl:max-w-[1400px] xl:px-8">
      <div className="pb-4 text-xl font-bold text-slate-900 md:pb-6 md:text-2xl">
        Lesson Resources
      </div>
      <div className="flex flex-wrap">
        <div
          className={cn(
            "basis-full",
            latestResources?.length ? "xl:basis-1/3" : "xl:basis-1/2",
          )}
        >
          <Card className="m-0 mb-4 border-[#b5e61d] xl:mr-2" title="By Course">
            {userCanManageCourses && (
              <ManageCoursesLink className="w-full mb-3" href={manageCoursesHref} />
            )}
            <div className="flex flex-col gap-4">
              <CoursesDropdown
                courseGroups={courseGroups}
                onChange={handleCourseChange}
                startOpen={!selectedCourseId}
                value={selectedCourseId}
              />
              {selectedCourse && (
                <UnitSelector
                  defaultOpenModules={[initialModuleId]}
                  hideTagWhenOpen
                  modules={selectedCourseModules}
                  onSelect={(unit) => {
                    posthogEventResourceGroupSelected({
                      triggerId: "downloadables-unit-selector-item",
                      groupType: "unit",
                      unit,
                      course: selectedCourse,
                    });
                    window.location = `/downloadables.php?cuid=${unit.cuid}`;
                  }}
                  type="multiple"
                />
              )}
            </div>
          </Card>
        </div>
        {!!latestResources?.length && (
          <div className="basis-full xl:basis-1/3">
            <RecentlyAdded latestResources={latestResources} />
          </div>
        )}
        <div
          className={cn(
            "basis-full",
            latestResources?.length ? "xl:basis-1/3" : "xl:basis-1/2",
          )}
        >
          <Links collections={collections} enrichment={enrichment} />
        </div>
      </div>
    </div>
  );
};

export default LessonResourcesHome;
